<template>
  <div class="query-order-page">
    <!-- 时间选择区域 -->
    <div class="time-picker-section">
      <label for="startTime">开始时间:</label>
      <input type="datetime-local" id="startTime" v-model="startTime">
      <label for="endTime">结束时间:</label>
      <input type="datetime-local" id="endTime" v-model="endTime">
      <button @click="queryOrders">查询订单</button>
      <!-- 新增复制按钮 -->
      <button @click="copyOrderData">复制数据</button>
    </div>
    <!-- 订单列表展示区域 -->
    <div class="order-list">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>支付金额</th>
            <!-- <th>支付状态</th> -->
            <th>支付渠道</th>
            <th>创建时间</th>
            <th>修改时间</th>
            <th>备注</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="order in orderList" :key="order.id">
            <td>{{ order.id }}</td>
            <td>{{ order.payMonery }}</td>
            <!-- <td>{{ order.payStatus }}</td> -->
            <td>{{ order.payChannel }}</td>
            <td>{{ order.createdTime }}</td>
            <td>{{ order.modifiedTime }}</td>
            <td>{{ order.summary }}</td>
          </tr>
        </tbody>
      </table>
      <!-- 新增金额合计显示 -->
      <div>金额合计: {{ totalAmount }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      startTime: '',
      endTime: '',
      orderList: [],
      token: '',
      timestamp: 0,
      // 新增 totalAmount 用于存储金额合计
      totalAmount: 0 
    };
  },
  mounted() {
    this.getTokenAndTimestamp();
  },
  methods: {
    // 获取 token 和 timestamp，方法和 AmountCYInputPage.vue 一致
    getTokenAndTimestamp() {
      // 这里需要根据 AmountCYInputPage.vue 中的实际实现进行编写
      // 示例代码，实际需要替换
      this.token = 'your_token'; 
      this.timestamp = Date.now();
    },
    // 查询订单方法
    async queryOrders() {
      const urlParams = new URLSearchParams(this.$route.query);
      const channelId = parseInt(urlParams.get('channelId')) || 0;
      const gameid = parseInt(urlParams.get('gameid')) || 0;

      // 转换为北京时间
      const formattedStartTime = this.convertToBeijingTime(this.startTime);
      const formattedEndTime = this.convertToBeijingTime(this.endTime);

      const requestData = {
        channelId,
        startTime: formattedStartTime,
        endTime: formattedEndTime,
        token: this.token,
        gameid,
        timestamp: this.timestamp
      };

      try {
        //const response = await fetch('http://localhost:5053/api2/QueryOrder', {
        // const response = await fetch('https://page.sverta.makeup/api2/QueryOrder', {
          const response = await fetch(`${window.location.origin}/api2/QueryOrder`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestData)
        });

        const data = await response.json();
        if (data.code === 1) {
          this.orderList = data.list;
          // 计算金额合计
          this.totalAmount = this.orderList.reduce((sum, order) => sum + (parseFloat(order.payMonery) || 0), 0);
        } else {
          console.error('查询订单失败:', data.message);
        }
      } catch (error) {
        console.error('请求出错:', error);
      }
    },
    // 修正后的转换为北京时间的方法
    convertToBeijingTime(dateString) {
      if (!dateString) return '';
      // 创建一个新的 Date 对象
      const localDate = new Date(dateString);
      // 获取本地时间戳
      const localTimestamp = localDate.getTime();
      // 计算本地时区偏移量（分钟）
      const localOffset = localDate.getTimezoneOffset();
      // 北京时间偏移量（东八区，480 分钟）
      const beijingOffset = 480;
      // 计算北京时间的时间戳
      const beijingTimestamp = localTimestamp + (localOffset + beijingOffset+ beijingOffset ) * 60 * 1000;
      // 创建北京时间的 Date 对象
      const beijingDate = new Date(beijingTimestamp);
      // 格式化为 ISO 字符串
      return beijingDate.toISOString();
    },
    // 新增复制方法
    copyOrderData() {
      const dataToCopy = this.orderList.map(order => Object.values(order).join('\t')).join('\n');
      navigator.clipboard.writeText(dataToCopy)
        .then(() => {
          console.log('数据复制成功');
        })
        .catch(err => {
          console.error('数据复制失败:', err);
        });
    }
  }
};
</script>

<style scoped>
/* 增大页面容器宽度 */
.query-order-page {
  padding: 50px; /* 增大页面内边距 */
  max-width: 1920px; /* 设置最大宽度，适合电脑屏幕 */
  margin: 0 auto; /* 水平居中 */
  font-size: 18px; /* 增大基础字体大小 */
  /* 新增以下样式，确保在不同屏幕尺寸下都能左右居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.time-picker-section {
  margin-bottom: 50px; /* 增大时间选择区域的底部外边距 */
  display: flex;
  align-items: center;
  gap: 30px; /* 增大元素间的间距 */
}

.time-picker-section label {
  font-size: 20px; /* 增大标签字体大小 */
  min-width: 120px; /* 新增：设置最小宽度以加宽标签 */
  display: inline-block; /* 确保 min-width 生效 */
}

.time-picker-section input[type="datetime-local"] {
  padding: 12px; /* 增大输入框内边距 */
  font-size: 18px; /* 增大输入框字体大小 */
  min-width: 350px; /* 增大输入框最小宽度，从 250px 增加到 350px */
  border: 2px solid #ccc; /* 添加边框 */
  border-radius: 8px; /* 圆角边框 */
  transition: border-color 0.3s ease; /* 添加过渡效果 */
}

.time-picker-section input[type="datetime-local"]:focus {
  border-color: #007bff; /* 聚焦时改变边框颜色 */
  outline: none; /* 移除默认聚焦轮廓 */
}

.time-picker-section button {
  padding: 15px 30px; 
  font-size: 18px; 
  cursor: pointer; 
  background-color: #007bff; 
  color: white; 
  border: none; 
  border-radius: 8px; 
  transition: background-color 0.3s ease; 
  min-width: 200px; /* 新增：设置按钮最小宽度以加宽按钮 */
}

.time-picker-section button:hover {
  background-color: #0056b3; 
}

.order-list table {
  width: 100%;
  border-collapse: collapse;
}

/* 加宽表格表头和单元格的最小宽度 */
.order-list th,
.order-list td {
  border: 1px solid #ddd;
  padding: 15px; /* 增大表格单元格内边距 */
  text-align: left;
  font-size: 18px; /* 增大表格字体大小 */
  min-width: 150px; /* 新增：设置最小宽度以加宽列 */
}

.order-list th {
  background-color: #f2f2f2;
  font-size: 20px; /* 增大表头字体大小 */
}
</style>